import Layout from '@/layout';
var paymentsRouter = {
  path: '/payments',
  component: Layout,
  redirect: '/payments/list',
  name: 'payments',
  meta: {
    title: '打款核销',
    icon: 'payments'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/payments/list');
    },
    name: 'paymentsList',
    meta: {
      title: '打款核销',
      icon: 'payments'
    }
  }]
};
export default paymentsRouter;